import { useEffect, useState } from "react";
import {isSSR} from "../utils/helpers";

export const useWindowWidth = () => {
  const [width, setWidth] = useState(() => isSSR() ? 0 : window.innerWidth);
  
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  return width;
};
